import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/** `@handle` that reads correctly inside Arabic: `<Handle user="demo.gallery" />` → ‎@demo.gallery. */
export function Handle({ user, className }: { user: string; className?: string }) {
  const u = user.replace(/^@/, "");
  return (
    <bdi dir="ltr" className={className}>
      @{u}
    </bdi>
  );
}

/** Left-to-right islands inside RTL text: emails, URLs, numbers with units, codes. */
export function Ltr({ children, className, num }: { children: ReactNode; className?: string; num?: boolean }) {
  return (
    <bdi dir="ltr" className={cn(num && "num", className)}>
      {children}
    </bdi>
  );
}
